export default "__VITE_ASSET__B3Xc5Hwf__"